import { Component, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { config, GameQuery, FGBTranslationLoader, FGBMissingTranslationHandler } from '@fgb/core';
import { TranslateModule, TranslateLoader, MissingTranslationHandler } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { LoadingModule } from '@fgb/portal-component-library/src/lib/shared/loading';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@fgb/core';
import * as ɵngcc2 from '@angular/common';
import * as ɵngcc3 from '@fgb/portal-component-library/src/lib/shared/loading';
import * as ɵngcc4 from '@ngx-translate/core';

function GameBannerComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "div", 3);
    ɵngcc0.ɵɵelementStart(3, "div", 4);
    ɵngcc0.ɵɵelementStart(4, "div", 5);
    ɵngcc0.ɵɵelementStart(5, "div", 6);
    ɵngcc0.ɵɵelement(6, "img", 7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "div", 8);
    ɵngcc0.ɵɵelementStart(8, "div", 4);
    ɵngcc0.ɵɵelementStart(9, "div", 9);
    ɵngcc0.ɵɵelementStart(10, "div", 10);
    ɵngcc0.ɵɵtext(11);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(12, "div", 11);
    ɵngcc0.ɵɵelementStart(13, "div", 12);
    ɵngcc0.ɵɵtext(14);
    ɵngcc0.ɵɵpipe(15, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(16, "div", 9);
    ɵngcc0.ɵɵelementStart(17, "div", 10);
    ɵngcc0.ɵɵtext(18);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(19, "p", 13);
    ɵngcc0.ɵɵtext(20);
    ɵngcc0.ɵɵpipe(21, "date");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(22, "div", 5);
    ɵngcc0.ɵɵelementStart(23, "div", 6);
    ɵngcc0.ɵɵelement(24, "img", 7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const game_r3 = ctx.ngIf;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵpropertyInterpolate("src", ctx_r0.getTeamLogoUrl(game_r3.HomeTeamId), ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵtextInterpolate(game_r3.TeamNames.HomeTeamName);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(15, 6, "cl.game.banner.vs.text"));
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate(game_r3.TeamNames.AwayTeamName);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind2(21, 8, game_r3.Date, "d MMM y HH:mm"));
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵpropertyInterpolate("src", ctx_r0.getTeamLogoUrl(game_r3.AwayTeamId), ɵngcc0.ɵɵsanitizeUrl);
} }
function GameBannerComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "fgbcl-loading");
} }
class GameBannerComponent {
    constructor(gameQuery) {
        this.gameQuery = gameQuery;
    }
    ngOnInit() {
        this.game$ = this.gameQuery.selectActive();
    }
    getTeamLogoUrl(teamId) {
        return `${config.contentUrl}/image/teams/${teamId}__1_1_1033.png`;
    }
}
GameBannerComponent.ɵfac = function GameBannerComponent_Factory(t) { return new (t || GameBannerComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.GameQuery)); };
GameBannerComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: GameBannerComponent, selectors: [["fgbcl-game-banner"]], decls: 4, vars: 4, consts: [[4, "ngIf", "ngIfElse"], ["loading", ""], [1, "w-100", "game-banner", "mb-5", "text-center"], [1, "container"], [1, "row"], [1, "col-3"], [1, "team-logo-container"], ["draggable", "false", 3, "src"], [1, "col-6", "teams-information-container"], [1, "col-5"], [1, "team-name", "font-weight-bold"], [1, "col-2"], [1, "font-weight-bold", "vs"], [1, "game-banner-date", "font-weight-bold"]], template: function GameBannerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, GameBannerComponent_ng_container_0_Template, 25, 11, "ng-container", 0);
        ɵngcc0.ɵɵpipe(1, "async");
        ɵngcc0.ɵɵtemplate(2, GameBannerComponent_ng_template_2_Template, 1, 0, "ng-template", null, 1, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = ɵngcc0.ɵɵreference(3);
        ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(1, 2, ctx.game$))("ngIfElse", _r1);
    } }, directives: [ɵngcc2.NgIf, ɵngcc3.LoadingComponent], pipes: [ɵngcc2.AsyncPipe, ɵngcc4.TranslatePipe, ɵngcc2.DatePipe], styles: [".team-logo-container[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{height:56px}.team-name[_ngcontent-%COMP%], p[_ngcontent-%COMP%]{font-size:12px}.vs[_ngcontent-%COMP%]{font-size:32px}@media only screen and (min-width:768px){.game-container[_ngcontent-%COMP%]{height:200px}.team-logo-container[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{height:130px}.teams-information-container[_ngcontent-%COMP%]{margin-top:50px}.team-name[_ngcontent-%COMP%]{font-size:25px}p[_ngcontent-%COMP%]{font-size:14px}}"] });
GameBannerComponent.ctorParameters = () => [
    { type: GameQuery }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(GameBannerComponent, [{
        type: Component,
        args: [{
                selector: 'fgbcl-game-banner',
                template: "<ng-container *ngIf=\"game$ | async as game; else loading\">\r\n  <div class=\"w-100 game-banner mb-5 text-center\">\r\n    <div class=\"container\">\r\n      <div class=\"row\">\r\n        <div class=\"col-3\">\r\n          <div class=\"team-logo-container\">\r\n            <img src=\"{{ getTeamLogoUrl(game.HomeTeamId) }}\" draggable=\"false\" />\r\n          </div>\r\n        </div>\r\n        <div class=\"col-6 teams-information-container\">\r\n          <div class=\"row\">\r\n            <div class=\"col-5\">\r\n              <div class=\"team-name font-weight-bold\">{{ game.TeamNames.HomeTeamName }}</div>\r\n            </div>\r\n            <div class=\"col-2\">\r\n              <div class=\"font-weight-bold vs\">{{ 'cl.game.banner.vs.text' | translate }}</div>\r\n            </div>\r\n            <div class=\"col-5\">\r\n              <div class=\"team-name font-weight-bold\">{{ game.TeamNames.AwayTeamName }}</div>\r\n            </div>\r\n          </div>\r\n          <p class=\"game-banner-date font-weight-bold\">{{ game.Date | date: 'd MMM y HH:mm' }}</p>\r\n        </div>\r\n        <div class=\"col-3\">\r\n          <div class=\"team-logo-container\">\r\n            <img src=\"{{ getTeamLogoUrl(game.AwayTeamId) }}\" draggable=\"false\" />\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</ng-container>\r\n<ng-template #loading>\r\n  <fgbcl-loading></fgbcl-loading>\r\n</ng-template>\r\n",
                styles: [".team-logo-container img{height:56px}.team-name,p{font-size:12px}.vs{font-size:32px}@media only screen and (min-width:768px){.game-container{height:200px}.team-logo-container img{height:130px}.teams-information-container{margin-top:50px}.team-name{font-size:25px}p{font-size:14px}}"]
            }]
    }], function () { return [{ type: ɵngcc1.GameQuery }]; }, null); })();

class GameBannerModule {
}
GameBannerModule.ɵfac = function GameBannerModule_Factory(t) { return new (t || GameBannerModule)(); };
GameBannerModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: GameBannerModule });
GameBannerModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            LoadingModule,
            TranslateModule.forRoot({
                loader: {
                    provide: TranslateLoader,
                    useClass: FGBTranslationLoader,
                    deps: [HttpClient]
                },
                missingTranslationHandler: {
                    provide: MissingTranslationHandler,
                    useClass: FGBMissingTranslationHandler
                }
            }),
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(GameBannerModule, { declarations: function () { return [GameBannerComponent]; }, imports: function () { return [CommonModule,
        LoadingModule, ɵngcc4.TranslateModule]; }, exports: function () { return [GameBannerComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(GameBannerModule, [{
        type: NgModule,
        args: [{
                declarations: [GameBannerComponent],
                imports: [
                    CommonModule,
                    LoadingModule,
                    TranslateModule.forRoot({
                        loader: {
                            provide: TranslateLoader,
                            useClass: FGBTranslationLoader,
                            deps: [HttpClient]
                        },
                        missingTranslationHandler: {
                            provide: MissingTranslationHandler,
                            useClass: FGBMissingTranslationHandler
                        }
                    }),
                ],
                exports: [GameBannerComponent]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { GameBannerComponent, GameBannerModule };

//# sourceMappingURL=fgb-portal-component-library-src-lib-tickettransfer-game-banner.js.map